module.exports = "/images/GC-What we do-01.jpg";